<div class="copy" appCopyToClipboard [copyClipboard]="stringifyData" [message]="message">
  <mat-icon class="ml-2 default-color">content_copy</mat-icon>
</div>
<pre class="default-color">{{ data | json }}</pre>
